import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Home, Search } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
    document.title = "404 - Page Not Found | NameBioLab";
    
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "404 - Page Not Found",
      "description": "The page you're looking for doesn't exist. Return to NameBioLab homepage or use our AI username and bio generator.",
      "url": `https://namebiolab.lovable.app${location.pathname}`
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [location.pathname]);

  return (
    <main className="flex min-h-screen items-center justify-center bg-background">
      <div className="container mx-auto px-4 text-center max-w-2xl">
        <h1 className="mb-6 text-6xl md:text-8xl font-bold bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
          404
        </h1>
        <h2 className="mb-4 text-2xl md:text-3xl font-semibold">Page Not Found</h2>
        <p className="mb-8 text-lg text-muted-foreground max-w-md mx-auto">
          Sorry, the page you're looking for doesn't exist. The username generator, bio maker, and all our free AI tools are available on the homepage.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/">
            <Button size="lg" className="gap-2">
              <Home className="h-4 w-4" />
              Back to Homepage
            </Button>
          </Link>
          <Link to="/#generator">
            <Button size="lg" variant="outline" className="gap-2">
              <Search className="h-4 w-4" />
              Try Username Generator
            </Button>
          </Link>
        </div>
        <div className="mt-12 text-sm text-muted-foreground">
          <p className="mb-2">Popular pages:</p>
          <div className="flex flex-wrap gap-2 justify-center">
            <Link to="/" className="text-primary hover:underline">Home</Link>
            <span>•</span>
            <Link to="/about" className="text-primary hover:underline">About</Link>
            <span>•</span>
            <Link to="/contact" className="text-primary hover:underline">Contact</Link>
            <span>•</span>
            <Link to="/privacy" className="text-primary hover:underline">Privacy</Link>
          </div>
        </div>
      </div>
    </main>
  );
};

export default NotFound;
